import { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";
import { success } from "../../hooks/global/ToastAlert";

function WidgetElement({ vendorId, lng, width, height, type, orientation, selectedModuleQueryParam, selectedElementQueryParam, showCopyToClipboardMessage = true }) {
  const { t } = useTranslation();
  const [showCode, setShowCode] = useState(false);
  const [copied, setCopied] = useState(false);

  t("admin.wid.suc");


  let reqUrl = `${process.env.REACT_APP_BASE_URL}/widgets/?type=${type}&orientation=${orientation}&size=${width}&vendorId=${vendorId}&language=${lng}`;
  if (selectedModuleQueryParam) {
    reqUrl += "&moduleId=" + selectedModuleQueryParam.id;
  }
  if (selectedElementQueryParam) {
    reqUrl += "&elementId=" + selectedElementQueryParam.id;
  }

  const codeSnippet = `<iframe src="${reqUrl}" width="${width}px" height="${height}px" title="${vendorId}" style="border:none;"></iframe>`;

  useEffect(() => {
    if (copied && showCopyToClipboardMessage) {
      success(t("admin.wid.suc"));
      setCopied(false);
    }
  }, [copied, showCopyToClipboardMessage]);

  return (
    <div className="widgetCode">
      <div className="iframeWrap">
        <iframe title={vendorId} src={reqUrl} width={`${width}px`} height={`${height}px`} />
      </div>
      {showCode ? (
        <>
          <code>{codeSnippet}</code>
          <CopyToClipboard text={codeSnippet} onCopy={() => setCopied(true)}>
            <p className="showCode">{t("admin.wid.cpy")}</p>
          </CopyToClipboard>
        </>
      ) : (
        <p className="showCode" onClick={() => setShowCode(!showCode)}>
          {t("admin.wid.sh")}
        </p>
      )}
    </div>
  );
}

export default WidgetElement;
